module.exports = __webpack_public_path__ + "img/category-brand-hover.4ff2f08c.png";